<template>
  <div class="fade-in">
    <h1 class="title">Edit an Account</h1>

    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      class="column is-two-thirds-desktop account-form"
    >
      <formly-form
        v-if="optionsReady"
        :form="form"
        :model="model"
        :fields="fields"
      ></formly-form>
      <p v-if="model.visuwellPartnerTokenFull">
        To update the token enter a new value above <br /><br />
        <span v-if="showFullToken">{{ model.visuwellPartnerTokenFull }}</span>
        <span v-else>**************{{ model.visuwellPartnerTokenLast4 }}</span>
        &nbsp;&nbsp;<a @click.prevent="toggleFullToken"
          ><span v-if="showFullToken">Hide</span> <span v-else>Show</span></a
        >
      </p>
      <div class="field is-grouped mt2">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            Update
          </button>
        </div>
        <div class="control">
          <router-link :to="{ name: 'practice-list' }" class="button is-link"
            >Cancel</router-link
          >
        </div>
      </div>
    </form>

    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import _ from "lodash";
import VueToastr from "vue-toastr";
import PracticesService from "@/services/PracticesService";
import fields from "@/components/practice/fields";

export default {
  name: "practice-edit",

  mixins: [fields],

  props: ["id"],

  components: {
    VueToastr
  },

  data() {
    return {
      showFullToken: false,
      loading: false,
      optionsReady: false,
      model: {
        id: null,
        parentId: ""
      }
    };
  },
  methods: {
    toggleFullToken() {
      this.showFullToken = !this.showFullToken;
    },
    onSubmit() {
      this.loading = true;
      PracticesService.update(this.model)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "practice-list" });
          this.$refs.toastr.e("The practice has been updated.");
        })
        .catch(errors => {
          this.loading = false;
          this.setErrors(errors);
          this.$refs.toastr.e("There was an error updating the practice.");
        });
    },
    getPractices() {
      return new Promise(resolve => {
        const practices = this.$store.getters["practice/list"];
        resolve(practices);
      });
    },
    finishSetup(practice) {
      this.model = { ...this.model, ...practice.attributes, id: practice.id };

      // remove subdomain as it isn't editable
      const subdomainIndex = _.findIndex(this.fields, ["key", "subdomain"]);
      this.fields.splice(subdomainIndex, 1);

      if (!this.model.productTable) {
        this.model.productTable = [
          { productCode: null, quantity: 1, price: 1000 }
        ];
      }
      this.getPractices().then(practices => {
        const index = _.findIndex(this.fields, ["key", "parentId"]);
        const practiceOptions = this.getPracticeOptions(practices);
        this.fields[index].options = this.fields[index].options.concat(
          practiceOptions
        );
      });
      this.setTimezones();
      this.optionsReady = true;
    }
  },

  mounted() {
    const practice = this.$store.getters["practice/get"](this.$props.id);
    if (!practice) {
      PracticesService.get(this.$props.id).then(practice => {
        this.finishSetup(practice);
      });
    } else {
      this.finishSetup(practice);
    }
  }
};
</script>

<style lang="scss"></style>
